import React from 'react';
import styled from 'styled-components';
import { sectionMargins, visuallyHidden } from '../styles';
import { Container } from './ui';
import PriceCard from './PriceCard';

const StyledPriceCards = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled.h2`
  ${visuallyHidden()};
`;

const StyledItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const PriceCards = ({ heading, items }) => (
  <StyledPriceCards>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map((item, id) => (
          <PriceCard key={id} {...item} />
        ))}
      </StyledItems>
    </Container>
  </StyledPriceCards>
);

export default PriceCards;
